/** @prettier */
import {Box, Button, ButtonProps, CircularProgress} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import {MouseEventHandler} from 'react';

type ButtonPropsType = {
  /** ボタンクリック時処理 */
  onClick: MouseEventHandler<HTMLButtonElement>;
  /** ボタンに表記する文字列 */
  buttonText: string;
  /** ID */
  id?: ButtonProps['id'];
  /** disabled */
  disabled?: ButtonProps['disabled'];
  className?: ButtonProps['className'];
  apiWait?: boolean;
  startIcon?: ButtonProps['startIcon'];
};
/**
 * Primaryボタン(OK,Apply,SAVE)
 * @param props props
 * @returns JSX
 */
const PrimaryButton = (props: ButtonPropsType) => {
  return (
    <Button
      onClick={props.onClick}
      color="primary"
      variant="contained"
      id={props.id}
      disabled={props.disabled}
      className={props.className}
      startIcon={props.startIcon}>
      {props.apiWait ? <CircularProgress size={20} /> : <>{props.buttonText}</>}
    </Button>
  );
};
/**
 * Secondaryボタン(CANCEL,CLOSE)
 * @param props props
 * @returns JSX
 */
const SecondaryButton = (props: ButtonPropsType) => {
  return (
    <Button
      onClick={props.onClick}
      color="secondary"
      id={props.id}
      disabled={props.disabled}
      className={props.className}
      startIcon={props.startIcon}>
      {props.apiWait ? <CircularProgress size={20} /> : <>{props.buttonText}</>}
    </Button>
  );
};
/**
 * Addボタン
 * @param props props
 * @returns JSX
 */
const AddButton = (props: ButtonPropsType) => {
  return (
    <Button
      onClick={props.onClick}
      color="primary"
      variant="contained"
      id={props.id}
      disabled={props.disabled}
      className="basicButton__addButton"
      startIcon={<AddIcon />}>
      <Box className="basicButton__addButton__text">{props.buttonText}</Box>
    </Button>
  );
};

export {PrimaryButton, SecondaryButton, AddButton};
